(() => {
  'use strict';

  const rootPath = window.Shopify?.routes?.root || '/';
  const route = (path) => `${rootPath}${path}`;

  document.querySelectorAll('[data-three-product-offer]').forEach((offer) => {
    const form = offer.querySelector('[data-offer-form]');
    const button = form?.querySelector('[data-offer-submit]');
    const label = button?.querySelector('[data-offer-label]');
    const errorNode = form?.querySelector('[data-offer-error]');
    if (!form || !button || !label || !errorNode) return;
    let inFlight = false;

    const showError = (message) => {
      errorNode.textContent = message;
      errorNode.hidden = !message;
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      showError('');
      if (inFlight) return;

      const items = [...offer.querySelectorAll('[data-offer-item]')].map((item) => ({
        id: Number(item.dataset.variantId),
        quantity: 1,
      }));
      const ids = new Set(items.map((item) => item.id));
      if (items.length !== 3 || ids.size !== 3 || items.some((item) => !Number.isSafeInteger(item.id) || item.id <= 0)) {
        showError('Set ürünleri şu anda doğrulanamıyor. Ürün detaylarından ayrı ayrı sepete ekleyebilirsiniz.');
        return;
      }

      const originalLabel = label.textContent;
      inFlight = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      label.textContent = 'Sepete ekleniyor…';

      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(route('cart/add.js'), {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
          signal: controller.signal,
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(typeof data.description === 'string' ? data.description : 'Ürünler sepete eklenemedi. Lütfen tekrar deneyin.');
        }
        window.location.assign(route('cart'));
      } catch (error) {
        const ambiguous = error.name === 'AbortError' || error instanceof TypeError || error instanceof SyntaxError;
        showError(ambiguous
          ? 'Sepet yanıtı alınamadı. Tekrar eklemeden önce sepetinizi kontrol edin.'
          : error.message);
        button.disabled = false;
        button.removeAttribute('aria-busy');
        label.textContent = originalLabel;
      } finally {
        window.clearTimeout(timeout);
        inFlight = false;
      }
    });
  });
})();
